import React from 'react';
import AccountMenuDI from '@atlassian/account-menu';
import {
	useAtlassianPersonalSettingsLink,
	useProfileLink,
	useSwitchAccountLink,
} from '@atlassian/jira-navigation-apps-common/src/utils/index.tsx';
import { testIdGenerate } from '@atlassian/jira-navigation-apps-common/src/utils/test-id.tsx';
import { useCurrentUser as useCurrentUserDI } from '@atlassian/jira-platform-services-user-current/src/main.tsx';
import { useThemePreference } from '@atlassian/jira-router-resources-theme-preference/src/controllers/resource-erai-1615-old/index.tsx';
import { NAVIGATION_ITEM_ID } from '../../common/constants.tsx';
import { TopLevelErrorBoundary } from '../../common/ui/error-boundary/index.tsx';
import { useUserBoardId as useUserBoardIdDI } from '../../controllers/user-board/index.tsx';
import { MenuNav4 as MenuNav4DI } from './menu/main-nav4.tsx';
import type { ProfileProps } from './types.tsx';

const Nav4Profile = ({
	AccountMenu = AccountMenuDI,
	MenuNav4 = MenuNav4DI,
	// eslint-disable-next-line react-hooks/react-compiler
	useCurrentUser = useCurrentUserDI,
	// eslint-disable-next-line react-hooks/react-compiler
	useUserBoardId = useUserBoardIdDI,
}: ProfileProps) => {
	const { theme, setTheme } = useThemePreference();
	const {
		data: { user },
		// eslint-disable-next-line react-hooks/react-compiler
	} = useCurrentUser();

	// @ts-expect-error - TS2339 - Property 'emailAddress' does not exist on type 'DataBasic | (DataBasic & User)'.
	const emailAddress = user.emailAddress || '';
	const atlassianSettingsLink = useAtlassianPersonalSettingsLink(emailAddress);
	const switchAccountLink = useSwitchAccountLink();
	const profileLink = useProfileLink();

	// eslint-disable-next-line react-hooks/react-compiler
	const [userBoardId, userBoardOwnerAccountId] = useUserBoardId(false);
	const testIdPrefix = testIdGenerate('secondary-actions', 'profile');

	if (user.isAnonymous) return null;

	return (
		<AccountMenu
			testId={testIdPrefix}
			// @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'DataBasic | (DataBasic & User)'.
			name={user.displayName}
			// @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & User)'.
			picture={user.avatarUrls ? user.avatarUrls['48x48'] : undefined}
			email={emailAddress}
			viewProfileLink={profileLink}
			manageProfileLink={atlassianSettingsLink}
			switchAccountLink={switchAccountLink}
			logOutLink="/logout"
			onThemeChange={setTheme}
			currentTheme={theme}
			extraMenuItems={
				<MenuNav4
					userBoardId={userBoardId}
					userBoardOwnerAccountId={userBoardOwnerAccountId}
					testIdPrefix={testIdPrefix}
				/>
			}
		/>
	);
};

const Profile = (props: ProfileProps) => <Nav4Profile {...props} />;

const ProfileWithErrorBoundary = (props: ProfileProps) => (
	<TopLevelErrorBoundary id={NAVIGATION_ITEM_ID.PROFILE}>
		<Profile {...props} />
	</TopLevelErrorBoundary>
);

export { ProfileWithErrorBoundary as Profile };
